import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { style: {"display":"none"} }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "split-table-layout" }
const _hoisted_15 = { class: "status" }
const _hoisted_16 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_17 = { class: "tab-title_left fl" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_ContactList = _resolveComponent("ContactList")!
  const _component_InvoiceInfoList = _resolveComponent("InvoiceInfoList")!
  const _component_TraceInfo = _resolveComponent("TraceInfo")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "公司名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.name) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "联系人", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.contactName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.contactName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "label" }, "手机", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.contactPhone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.contactPhone) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "客户级别", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.customerLevelId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.customerLevelId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_ctx.customerLevelOption.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.customerLevelOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          value: -1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode("暂无数据", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "客户来源", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.customerSourceId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.customerSourceId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_ctx.customerSourceOption.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.customerSourceOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.mark,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_component_el_option, {
                          key: 1,
                          value: -1,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                            _createTextVNode("暂无数据", -1)
                          ]))]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              (_ctx.fromType === 'ALL')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "付款周期", -1)),
                      _createVNode(_component_el_select, {
                        filterable: true,
                        modelValue: _ctx.listQuery.paymentCycleId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.paymentCycleId) = $event)),
                        class: "filter-item",
                        placeholder: "",
                        clearable: "",
                        size: _ctx.t('table.btnSize'),
                        onChange: _ctx.handleFilter
                      }, {
                        default: _withCtx(() => [
                          (_ctx.paymentCycleOption.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.paymentCycleOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.mark,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: -1,
                                disabled: ""
                              }, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createTextVNode("暂无数据", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "size", "onChange"])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_9, [
                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                      _createVNode(_component_el_select, {
                        filterable: true,
                        modelValue: _ctx.listQuery.salesManId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                        class: "filter-item",
                        placeholder: "",
                        clearable: "",
                        size: _ctx.t('table.btnSize'),
                        onChange: _ctx.handleFilter
                      }, {
                        default: _withCtx(() => [
                          (_ctx.salesManOption.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.salesManOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.mark,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: -1,
                                disabled: ""
                              }, {
                                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                  _createTextVNode("暂无数据", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "size", "onChange"])
                    ], 512), [
                      [_vShow, _ctx.showSalesManFilter]
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "省市县", -1)),
                      _createVNode(_component_el_cascader, {
                        filterable: true,
                        modelValue: _ctx.listQuery.address,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.address) = $event)),
                        props: _ctx.provincesLoad,
                        clearable: true,
                        placeholder: "",
                        onChange: _ctx.handleFilter
                      }, {
                        default: _withCtx(({ node, data }) => [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(node.isLeaf), 1),
                          _createElementVNode("span", null, _toDisplayString(data.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "props", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "审批状态", -1)),
                      _createVNode(_component_el_select, {
                        filterable: true,
                        modelValue: _ctx.listQuery.changeStatus,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.changeStatus) = $event)),
                        class: "filter-item",
                        placeholder: "",
                        clearable: "",
                        size: _ctx.t('table.btnSize'),
                        onChange: _ctx.handleFilter
                      }, {
                        default: _withCtx(() => [
                          (_ctx.ReviewStatusOption.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.ReviewStatusOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.mark,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_el_option, {
                                key: 1,
                                value: -1,
                                disabled: ""
                              }, {
                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                  _createTextVNode("暂无数据", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "size", "onChange"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[42] || (_cache[42] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[43] || (_cache[43] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: el => { if (el) _ctx.tableListRef[0] = el },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            isShowPagination: false,
            handleDefaultWidth: 120,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            canRefresh: false,
            canChangeColumn: false,
            canCommand: _ctx.canCommand,
            style: {"height":"calc(100% - 0px)","overflow":"hidden"},
            onCommandChange: _ctx.handleCommand,
            onRowClick: _ctx.handleRowClick
          }, {
            name: _withCtx((scope) => [
              _createElementVNode("span", {
                class: _normalizeClass([scope.row.changeStatus === 2 ? 'redStatusStyle' : scope.row.changeStatus === 1 ? 'yellowStatusStyle' : '', "statusStyle"])
              }, [
                (scope.row.changeStatus && scope.row.changeStatus !== 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[44] || (_cache[44] = _createElementVNode("i", { class: "iconfont icon-tubiao-40" }, null, -1)),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.ReviewStatusOption.find(k => k.id === scope.row.changeStatus) ? _ctx.ReviewStatusOption.find(k => k.id === scope.row.changeStatus).mark : ''), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
              ], 2)
            ]),
            "operation-action": _withCtx((scope) => [
              _createVNode(_component_CommandRender, {
                scopeRow: scope.row,
                codeList: _ctx.btnList,
                permissionName: _ctx.permissionName,
                onCommandChange: _ctx.handleCommand
              }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"])
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "canCommand", "onCommandChange", "onRowClick"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_18))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_ContactList, {
                key: 0,
                ref: "ContactList",
                id: _ctx.activeId,
                canCommand: _ctx.contactCanCommand
              }, null, 8, ["id", "canCommand"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2)
            ? (_openBlock(), _createBlock(_component_InvoiceInfoList, {
                key: 1,
                ref: "InvoiceInfoList",
                id: _ctx.activeId,
                canCommand: _ctx.invoiceCanCommand
              }, null, 8, ["id", "canCommand"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 3)
            ? (_openBlock(), _createBlock(_component_TraceInfo, {
                key: 2,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: 'customerCompany'
              }, null, 8, ["id"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          handleResolveTempData: _ctx.handleResolveTempData,
          api: 'customerCompany',
          "onUpdate:visibel": _cache[14] || (_cache[14] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "handleResolveTempData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.remindedVisible,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.remindedVisible) = $event)),
      title: "设置超期提醒",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.remindedVisible = false)),
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSetReminded
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.remindedVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_el_checkbox, {
                label: "超期未合作提醒",
                modelValue: _ctx.remindedCheckList.overdueWithoutBusinessNoticeSwitch,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.remindedCheckList.overdueWithoutBusinessNoticeSwitch) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                label: "超期未订单提醒",
                modelValue: _ctx.remindedCheckList.overdueWithoutOrderNoticeSwitch,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.remindedCheckList.overdueWithoutOrderNoticeSwitch) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                label: "超期未联系提醒",
                modelValue: _ctx.remindedCheckList.overdueWithoutContactNoticeSwitch,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.remindedCheckList.overdueWithoutContactNoticeSwitch) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_checkbox, {
                label: "超期未收款提醒",
                modelValue: _ctx.remindedCheckList.overdueWithoutPaymentNoticeSwitch,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.remindedCheckList.overdueWithoutPaymentNoticeSwitch) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.fpVisible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.fpVisible) = $event)),
      title: "分配业务员",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.fpVisible = false)),
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSetFp
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.fpVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "warming-fp" }, "提示：如果没有选择任何业务员，该客户公司将不属于任何一个业务员", -1)),
              _createVNode(_component_el_select, {
                filterable: true,
                modelValue: _ctx.salesManId,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.salesManId) = $event)),
                class: "filter-item",
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.salesManOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.salesManOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.yejiVisible,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.yejiVisible) = $event)),
      title: "设置业绩类型",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            onClick: _cache[26] || (_cache[26] = ($event: any) => {_ctx.yejiVisible = false;_ctx.achieveType = ''}),
            type: "danger"
          }, {
            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleSetYeji
          }, {
            default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
              _createTextVNode("确定", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.yejiVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.achieveType,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.achieveType) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yejiOption, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      label: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.mark), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}